module.exports = __webpack_public_path__ + "media/images/icon__checkmark--rb-dark-gray-29b36ec7d4e8624aad4f1b4de2f3992a.png";